import React from 'react';
import { useTranslation } from 'react-i18next';
import './BillingStatusBadge.css';

interface BillingStatusBadgeProps {
  /** null/undefined = report non ancora fatturabile o riga non ancora creata ("senza fatturazione"). */
  billingStatus?: string | null;
}

const BillingStatusBadge: React.FC<BillingStatusBadgeProps> = ({ billingStatus }) => {
  const { t } = useTranslation();

  const KNOWN_STATUSES = ['TO_VALIDATE', 'VALIDATED', 'INVOICED'];

  const getBillingStatusClass = (status?: string | null): string => {
    switch (status) {
      case 'TO_VALIDATE':
        return 'billing-status-badge-to-validate';
      case 'VALIDATED':
        return 'billing-status-badge-validated';
      case 'INVOICED':
        return 'billing-status-badge-invoiced';
      default:
        return 'billing-status-badge-none';
    }
  };

  // Un valore non riconosciuto ricade su "no billing" anche per l'etichetta, non solo per lo
  // stile: altrimenti t() restituirebbe la chiave grezza (es. "billing.status.XYZ") a schermo.
  const label = billingStatus && KNOWN_STATUSES.includes(billingStatus)
    ? t(`billing.status.${billingStatus}`)
    : t('billing.status.NONE');

  return (
    <span className={`billing-status-badge ${getBillingStatusClass(billingStatus)}`}>
      {label}
    </span>
  );
};

export default BillingStatusBadge;
